import * as moment from 'moment';
import { required, dataMember, typedArray } from 'santee-dcts';
import { deserializers } from '../core';

export class Announcement {
    @dataMember()
    @required()
    public titleAnnouncement: string;

    @dataMember()
    @required()
    public textAnnouncement: string;

    @dataMember()
    @required()
    public isPinned: boolean;

    @dataMember()
    @required()
    public isNew: boolean;
}

export class AnnouncementsReadModel {
    @dataMember()
    @required()
    @typedArray(Announcement)
    public announcements: Announcement[];
}